export async function setLocalSearchInput(value) {
  await localStorage.setItem('searchInput', value)
}

export async function getLocalSearchInput() {
  return await localStorage.getItem('searchInput')
}
